import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Field, reduxForm, reset, formValueSelector, change, clearFields } from 'redux-form';
import { connect, useDispatch } from 'react-redux';
import { flowRight as compose } from 'lodash';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Button from 'react-bootstrap/lib/Button';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import FormControl from 'react-bootstrap/lib/FormControl';

import { getWishListGroup } from '../../../lib/graphql';
import messages from '../../../locale/jsonMessages';
import validate from './validate';

import pluseIcon from '/public/SiteIcons/plus.svg';

import { withMutation } from '../../../hoc/withGraphql';
import { createWishListGroupMutation, createWishListMutation } from '../../../lib/graphql';

import cs from '../../../components/commonStyle.css';
import s from './CreateWishList.css';

const renderFormControl = ({ input, label, type, meta: { touched, error }, className, placeholder, isRequiredInput }) => {

    const intl = useIntl();
    return (
        <FormGroup className={cs.noMargin}>
            <label className='commonLabelText'>{label} {isRequiredInput && <span className='isRequiredStar'>*</span>}</label>
            <FormControl {...input} placeholder={placeholder} type={type} className={className} maxLength={255} />
            {touched && error && <span className={cs.errorMessage}>{intl.formatMessage(error)}</span>}
        </FormGroup>
    );
};

const CreateWishList = (props) => {
    const {
        handleSubmit,
        submitting,
        listId,
        profileId,
        wishListGroups,
        change,
        clearFields,
        createWishListGroup,
        createWishList
    } = props;

    const [shown, setShown] = useState(true);
    const intl = useIntl();
    const dispatch = useDispatch();

    const toggle = () => {
        setShown(!shown);
        clearFields(false, false, 'name');
        change('name', null);
    };


    const submitForm = async (values) => {
        if (values?.name?.trim() !== '') {
            let updatedWishLists = wishListGroups;

            const { data } = await createWishListGroup({
                variables: values,
            });

            if (data?.CreateWishListGroup?.status === 'success') {
                setShown(!shown);

                const {
                    data: { CreateWishList }
                } = await createWishList({
                    variables: {
                        listId: Number(listId),
                        wishListGroupsId: data.CreateWishListGroup.id,
                        eventKey: true
                    },
                    refetchQueries: [{
                        query: getWishListGroup,
                        variables: { profileId }
                    }]
                });

                updatedWishLists.push(data.CreateWishListGroup.id);
                await change('WishListModalForm', 'wishListGroups', updatedWishLists);
                dispatch(reset('CreateWishList'));
            }
        }
    };

    return (
        <div>
            <form onSubmit={handleSubmit(submitForm)}>
                {shown ? (
                    <a
                        onClick={toggle}
                        className={cx(cs.siteLinkColor, cs.textDecorationNone, cs.curserPointer, cs.fontWeightMedium, cs.dFlex)}
                    >
                        <span className={s.plusIconSection}>
                            <img src={pluseIcon} className={s.plusIcon} />
                        </span>
                        <span className={s.createTextMargin}>
                            <FormattedMessage {...messages.createWishList} />
                        </span>
                    </a>
                ) : (
                    <>
                        <Field
                            name="name"
                            type="text"
                            label={intl.formatMessage(messages.createWishList)}
                            component={renderFormControl}
                            placeholder={intl.formatMessage(messages.name)}
                            isRequiredInput
                            className='commonInputField'
                        />
                        <div className={cx('doubleBtnFlexEnd', cs.spaceTop4)}>
                            <Button className={cs.btnPrimaryBorder} disabled={submitting} onClick={toggle}>
                                {intl.formatMessage(messages.cancel)}
                            </Button>
                            <Button className={cs.btnPrimary} type="submit">
                                {intl.formatMessage(messages.save)}
                            </Button>
                        </div>
                    </>
                )}
            </form>
        </div>
    );
};

CreateWishList.propTypes = {
    listId: PropTypes.number,
    profileId: PropTypes.number,
    wishListGroups: PropTypes.array,
    handleSubmit: PropTypes.func,
    submitting: PropTypes.bool,
    change: PropTypes.func,
    clearFields: PropTypes.func,
    createWishListGroup: PropTypes.func,
    createWishList: PropTypes.func
};

const selector = formValueSelector('WishListModalForm');

const mapState = (state) => ({
    listId: state?.modalStatus?.listId,
    profileId: state?.account?.data?.profileId,
    wishListGroups: selector(state, 'wishListGroups')
});

const mapDispatch = {
    change,
    clearFields
};

export default compose(
    withStyles(cs, s),
    connect(mapState, mapDispatch),
    withMutation(createWishListGroupMutation, { name: 'createWishListGroup' }),
    withMutation(createWishListMutation, { name: 'createWishList' }),
    reduxForm({
        form: 'CreateWishList',
        validate,
        destroyOnUnmount: false
    })
)(CreateWishList);
